const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHobbbiesCp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Using_Technology",
    "data-name": "Using Technology",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 25,
    r: 0.975,
    id: "id_101",
    style: {
      fill: "rgb(229, 69, 69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.03,19.03V23A1.029,1.029,0,0,1,20,24.03H16.03v1.94H20A1.029,1.029,0,0,1,21.03,27v3.64l.18.15.15.18h1.61V27A1.029,1.029,0,0,1,24,25.97h3.97V24.03H24A1.029,1.029,0,0,1,22.97,23V19.03Z",
    id: "id_102",
    style: {
      fill: "rgb(229, 69, 69)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 25,
    r: 0.975,
    id: "id_103",
    style: {
      fill: "rgb(229, 69, 69)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 20,
    r: 0.975,
    id: "id_104",
    style: {
      fill: "rgb(229, 69, 69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.76,33A3.019,3.019,0,1,1,45,29.76a3.641,3.641,0,0,1,2.32.58l3.55,2.37,2.1-2.1V17A2.97,2.97,0,0,0,50,14.03H33V9a3,3,0,0,1,3-3h9V4H36a5.006,5.006,0,0,0-5,5v5.03H14A2.97,2.97,0,0,0,11.03,17V30.61l2.1,2.1,3.55-2.37a3.649,3.649,0,0,1,2.29-.58V28.03H15A1.029,1.029,0,0,1,13.97,27V23A1.029,1.029,0,0,1,15,21.97h3.97V18A1.029,1.029,0,0,1,20,16.97h4A1.029,1.029,0,0,1,25.03,18v3.97H29A1.029,1.029,0,0,1,30.03,23v4A1.029,1.029,0,0,1,29,28.03H25.03V32A1.029,1.029,0,0,1,24,33.03H22.24a3.571,3.571,0,0,1-.58,2.29L17,42.3v5.67h.39a4.978,4.978,0,0,0,4.81-3.68.578.578,0,0,1,.05-.14l2.81-6.55a1.024,1.024,0,0,1,.94-.63H38a1.024,1.024,0,0,1,.94.63l2.81,6.55a.578.578,0,0,1,.05.14,4.978,4.978,0,0,0,4.81,3.68H47V42.3l-4.66-6.98A3.641,3.641,0,0,1,41.76,33Zm8.265-8A3.025,3.025,0,1,1,47,21.975,3.028,3.028,0,0,1,50.025,25ZM42,16.975A3.025,3.025,0,1,1,38.975,20,3.028,3.028,0,0,1,42,16.975Zm-5,11.05A3.025,3.025,0,1,1,40.025,25,3.028,3.028,0,0,1,37,28.025Z",
    id: "id_105",
    style: {
      fill: "rgb(229, 69, 69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.79,32.21a1.576,1.576,0,0,0-2-.2l-4.24,2.82a1,1,0,0,1-1.26-.12l-3-3A1.033,1.033,0,0,1,9,31H8.97V18H8.41a1.006,1.006,0,0,0-.94.66L4.99,28.18,4,37.06v4.7l2.89,5.79a.976.976,0,0,1,.07.71L4.31,58H15V42a.967.967,0,0,1,.17-.55l4.82-7.24A1.576,1.576,0,0,0,19.79,32.21Z",
    id: "id_106",
    style: {
      fill: "rgb(229, 69, 69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,41.76v-4.7l-.99-8.88-2.5-9.6a1.01,1.01,0,0,0-.92-.58h-.56V31H55a1.033,1.033,0,0,1-.29.71l-3,3a1,1,0,0,1-1.26.12l-4.24-2.82a1.587,1.587,0,0,0-2.2,2.2l4.82,7.24A.967.967,0,0,1,49,42V58H59.69l-2.65-9.74a.976.976,0,0,1,.07-.71Z",
    id: "id_107",
    style: {
      fill: "rgb(229, 69, 69)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 30,
    r: 0.97,
    id: "id_108",
    style: {
      fill: "rgb(229, 69, 69)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbbiesCp);
export default __webpack_public_path__ + "static/media/hobbbiesCP.8dc17cd48b8c93d29bf9e03a9e1d42f4.svg";
export { ForwardRef as ReactComponent };